/* global MutationObserver */

jQuery( $ => {
	// Wait for the document to be fully loaded
	// Trigger WooCommerce's variation check
	// This is a uickfix for hastas variable products for some reason not changing like they should.
	$( document ).ready( function() {
		$( '.variations_form' ).each( function() {
			$( this ).find( 'select' ).trigger( 'change' );
		} );
	} );

	// only run on the single product page. In some instances the current price shown is the same as the original price, so there is no need to show both prices, as they are the same.
	if ( $( '.single-product' ).length ) {
		// the function that decides if the current price shown is the same as the original price.
		function HideShowRealPrice() {
			if ( $( '.price ins .woocommerce-Price-amount bdi' ).first().text().length && $( '.summary .price del .woocommerce-Price-amount bdi' ).first().text().length ) {
				if ( $( '.price ins .woocommerce-Price-amount bdi' ).first().text() === $( '.summary .price del .woocommerce-Price-amount bdi' ).first().text() ) {
					$( '.summary .price del' ).first().hide();
				} else {
					$( '.summary .price del' ).first().show();
				}
			}
		}

		function sleep( ms ) {
			return new Promise( resolve => setTimeout( resolve, ms ) );
		}

		$( '#pa_bredd' ).change( async function() {
			$( '.summary .price del' ).first().hide();
			await sleep( 300 ); // Pause for .3 seconds, so that the other javascript can execute
			HideShowRealPrice();
		} );

		HideShowRealPrice();

		// Keep SKU element updated for variable products.
		// I don't like this any more than you do.
		( () => {
			const variationsForm = document.querySelector( 'form.variations_form' );
			if ( ! variationsForm ) {
				return;
			}

			const inputVariationId = variationsForm?.querySelector( 'input[name="variation_id"]' );
			if ( ! inputVariationId ) {
				return;
			}

			const skuWrapper = document.querySelector( '.product-sku-wrapper' );
			if ( ! skuWrapper ) {
				return;
			}

			const variations = JSON.parse( variationsForm?.dataset?.product_variations || '{}' );
			const productSkuElement = skuWrapper.querySelector( '.product-sku' );

			// Create an observer instance
			const observer = new MutationObserver( () => {
				const variationId = inputVariationId.value ?? '';
				const sku = variations.find( variation => variation.variation_id === +variationId )?.sku || '';

				skuWrapper.dataset.sku = sku;
				if ( productSkuElement ) {
					productSkuElement.innerText = sku;
				}
			} );

			observer.observe( inputVariationId, { attributes: true } );
		} )();
	}
} );
